export default __webpack_public_path__ + "static/s1-4239f0c69c275a2d8b507714a1d7b0f3.jpg";